// extracted by mini-css-extract-plugin
export default {"section":"Services_section__UF3nb","serviceGrid":"Services_serviceGrid__PwbN8","serviceCard":"Services_serviceCard__TeCon","serviceIcon":"Services_serviceIcon__l9vjb"};